import { SVGProps } from '@components/Icon/types';

export const Columns = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.7041 2.01074C9.71278 2.113 10.5 2.96435 10.5 4V20L10.4893 20.2041C10.387 21.2128 9.53565 22 8.5 22H4.5C3.46435 22 2.613 21.2128 2.51074 20.2041L2.5 20V4C2.5 2.89543 3.39543 2 4.5 2H8.5L8.7041 2.01074ZM4.5 3.40039C4.16863 3.40039 3.90039 3.66863 3.90039 4V20C3.90039 20.3314 4.16863 20.5996 4.5 20.5996H8.5C8.83137 20.5996 9.09961 20.3314 9.09961 20V4C9.09961 3.66863 8.83137 3.40039 8.5 3.40039H4.5Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7041 2.01074C20.7128 2.113 21.5 2.96435 21.5 4V20L21.4893 20.2041C21.387 21.2128 20.5357 22 19.5 22H15.5C14.4643 22 13.613 21.2128 13.5107 20.2041L13.5 20V4C13.5 2.89543 14.3954 2 15.5 2H19.5L19.7041 2.01074ZM15.5 3.40039C15.1686 3.40039 14.9004 3.66863 14.9004 4V20C14.9004 20.3314 15.1686 20.5996 15.5 20.5996H19.5C19.8314 20.5996 20.0996 20.3314 20.0996 20V4C20.0996 3.66863 19.8314 3.40039 19.5 3.40039H15.5Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'columns';
